var _circle, _circle2, _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#CAE0FD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8579,
    cy: 26.2279,
    r: 14.6053,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.3325,
    cy: 29.2497,
    rx: 1.00726,
    ry: 1.5109,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.3906,
    cy: 29.2497,
    rx: 1.00726,
    ry: 1.5109,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3761 32.7759H24.0953C24.0953 33.7831 24.8507 34.5386 26.3616 34.5386C27.7861 34.5386 28.2922 33.4474 28.3761 32.7759Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.54 12.0237C17.6901 7.99463 11.8144 18.7372 11.1429 25.1166V26.3757C12.5531 24.3612 17.4383 21.7286 20.9637 21.0876C23.7337 20.584 26.084 21.2555 27.2591 22.0949C29.0722 20.4832 36.9121 23.4378 40.6054 25.1166C41.109 20.8358 39.4302 18.3176 37.8354 17.5622C36.5763 14.2886 32.7151 12.4434 31.54 12.0237Z",
    fill: "#434379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2909 18.0335C13.0419 18.5421 12.4348 18.5898 11.1429 22.8653C16.9396 22.8653 29.0002 23.1912 40.8572 22.9223C40.8572 21.1428 39.7429 18.9429 38.7584 18.05C26.638 17.7811 18.8242 17.7358 13.2909 18.0335Z",
    fill: "#4F97F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile14);
export default __webpack_public_path__ + "static/media/img_profile_14.9ff162f12d67256eb1a1ff54f1f2423d.svg";
export { ForwardRef as ReactComponent };